import { Flex, Icon, SystemStyleObject, Text, Tooltip } from '@chakra-ui/react'
import React from 'react'
import IconVoicemail from '~/assets/svgs/icon-voicemail.svg?react'
import { QuickActionButtonVariants } from '~/components/shared/componentStyles/QuickActionButton.style'
import { QuickActionButton } from '~/components/shared/QuickActionButton'
import {
  CallOutcomeCellVariant,
  useCallOutcomeCellStyles,
} from '~/pages/Calls/componentStyles/CallsListItem.style'
import { Size } from '~/types/ThemeTypes'

import { toNounCasing } from '@mangovoice/core'
import { CallDirection } from '@mangovoice/types'

interface CallOutcomeCellProps {
  text: string
  icon: SVGComponent
  columnStyles: SystemStyleObject
  direction: CallDirection
  hasVoicemail?: boolean
  size?: Size
  variant: CallOutcomeCellVariant
  onVoicemailClick?: () => void
}
export const CallOutcomeCell = ({
  columnStyles,
  text,
  icon,
  direction,
  hasVoicemail,
  size,
  variant = CallOutcomeCellVariant.Success,
  onVoicemailClick,
}: CallOutcomeCellProps) => {
  const styles = useCallOutcomeCellStyles({ variant })

  const shouldCollapse = size === Size.sm || size === Size.md

  const tooltipText = `${toNounCasing(direction)}\n${text}`

  return (
    <Flex sx={{ ...columnStyles, ...styles.container }}>
      <Tooltip
        hasArrow
        placement="top"
        whiteSpace="pre-wrap"
        label={tooltipText}
        isDisabled={!shouldCollapse}
      >
        <Flex sx={styles.iconWrapper}>
          <Icon as={icon} sx={styles.icon} />
        </Flex>
      </Tooltip>
      {!shouldCollapse && <Text sx={styles.text}>{text}</Text>}
      {hasVoicemail && (
        <QuickActionButton
          actionIcon={IconVoicemail}
          variant={QuickActionButtonVariants.Default_100}
          size={Size.sm}
          tooltipText="Voicemail"
          onClick={onVoicemailClick}
        />
      )}
    </Flex>
  )
}
